import "selectric";

function selectJs(element) {
  $(element).selectric({
    arrowButtonMarkup: '<b class="button"></b>',
    allowWrap: false,
    expandToItemText: true,
    disableOnMobile: false,
    nativeOnMobile: false
  });
}

module.exports = {
  selectJs
};



// WEBPACK FOOTER //
// ../assets/js/select.js